import { onSuccess } from "./onSuccess";
import {
  AxiosResponseType,
  OnSubmitFormType,
  QuestionFormType,
} from "../SignUpFormTypes/signUpFormTypes";
import SPfetch from "@services/SPFetch.class";
import { logger } from "@utils/logger";
import { formatSuccessData } from "./formatSuccessData";
import ReCAPTCHA from "react-google-recaptcha";

export const onSubmitForm = async ({
  formData,
  recaptchaRef,
  finalTime,
  kountSessionId,
}: OnSubmitFormType) => {
  const getRecaptchaToken = async (
    myRef: React.RefObject<ReCAPTCHA>
  ): Promise<string | null> => {
    if (!myRef?.current) return null;

    const recaptchaToken = await myRef.current.executeAsync();

    if (!recaptchaToken) return null;

    return recaptchaToken;
  };

  const recaptchaToken =
    process.env.GATSBY_ENVIRONMENT !== "dev"
      ? await getRecaptchaToken(recaptchaRef)
      : null;

  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    globalProfessionId,
    termsOfServiceAcceptance,
    questions,
    otherProfession,
  } = formData;
  const successData = await formatSuccessData(
    formData,
    recaptchaToken!,
    kountSessionId
  );

  try {
    const name = `${firstName} ${lastName}`;
    const signupEndpoint = `${process.env.GATSBY_WS_URL}/api/signupSubmit`;

    const response = await SPfetch.post(signupEndpoint, successData);
    const responseJson: AxiosResponseType = await response.json();

    onSuccess({
      res: responseJson,
      email,
      name,
      phone: phoneNumber,
      profession: globalProfessionId,
      termsOfServiceAcceptance,
      reqEndTime: finalTime,
      questions: transformQuestionsArray(questions),
      otherProfession,
    });
  } catch (error) {
    logger(`helpers::SPFetch::post::${JSON.stringify(error)}`);
  }
};

function transformQuestionsArray(
  questions: QuestionFormType | string[]
): { [key: string]: string | string[] | null } | null {
  if (!questions.length) return null;

  const result: { [key: string]: string | string[] | null } = {};

  (questions as QuestionFormType).forEach(question => {
    if (Array.isArray(question.value)) {
      result[question.name] = question.value;
    } else {
      result[question.name] = question.value || "";
    }
  });

  return result;
}
